import React from 'react';
import { useParams } from 'react-router-dom';
import { OrphanEdit } from '.';
import { BrandKey, OrphanPageStatus } from '../../../__generated__/queries-web';

interface newPageParams {
  brandKey: BrandKey;
}
export const NewOrphanPage = () => {
  const { brandKey } = useParams<newPageParams>();
  return (
    <OrphanEdit
      defaultState={{
        brandKey,
        status: OrphanPageStatus.Draft,
        id: crypto.randomUUID(),
        title: '',
        url: '',
        metas: [],
        content: '',
        isCMPEnabled: true,
        isAdsEnabled: true,
        isFullScreen: true,
      }}
    />
  );
};
